export const discount = {
    header: 'Vous avez un code de coupon ?',
    usedVoucher: "Bon d'achat encaissé",
    inputLabels: {
        discountCode: 'Code de coupon',
    },
    voucherIsValid: 'Coupon valide!',
    voucherIsNotValid: 'Coupon non valide.',
    couldNotBeValidated: "Ce coupon n'est malheureusement pas valide. <br/>",
    loginRequired: 'Login nécessaire',
    voucherNeedsLogin:
        'Le code de bon saisi ne peut être utilisé que par les clients enregistrés.<br/><br/>Veuillez vous connecter ou vous enregistrer.<br/>',
    voucherMaxUsageReached: "Le nombre maximum d'utilisations pour le code de bon saisi a été atteint.",
    relativeDiscount:
        "Avec ce coupon, vous bénéficiez d'une réduction de <span class='has-text-primary-dark'>{value}%</span> .",
    absoluteDiscount:
        'Avec ce coupon, <span class="has-text-primary-dark">{value}€</span> seront déduits à la fin de votre commande.',
    absoluteDiscountBusinessCustomers:
        'Avec ce coupon, <span class="has-text-primary-dark">{value}€</span> net seront déduits à la fin de votre commande.',
    applicableXTimes:
        "Ce coupon n'est pas utilisable. | Vous ne pouvez utiliser ce coupon qu'une seule fois. | Vous ne pouvez utiliser ce coupon que {n} fois.",
    minimumOrderTotal:
        "Ce coupon n'est valable que pour les commandes d'un montant minimum de <span class='has-text-primary'>{amount}€</span> ",
    orderGoal:
        'Vous avez encore besoin de <span class="has-text-danger">{amount} €</span> pour encaisser ce coupon.',
    belowMinimumOrderTotal: 'Valeur minimale de commande non atteinte',
    freeShipping: 'Nous livrerons votre commande gratuitement.',
    actionLabels: {
        validateCode: 'Vérifier',
        cancel: 'Annuler',
        redeemDiscount: 'Utiliser le coupon',
        continueShopping: 'Continuez vos achats',
        tryAgain: 'Retourner',
        removeDiscount: 'Retirer',
    },
};
